import { createAction } from "redux-act";

export const PlaygroundUpdateAction = createAction("Playground Update");
export const PlaygroundUpdateRequestAction = createAction("Playground Update - Request");
export const PlaygroundUpdateSuccessAction = createAction("Playground Update - Success");
export const PlaygroundUpdateFailedAction = createAction("Playground Update - Failed");
